import Button from "./Button";
import Heading from "./Heading";
import Section from "./Section";
import Tagline from "./Tagline";
import { roadmap } from "../constants/data";
import { check2, grid, loading1 } from "../assets";
import { Gradient } from "./design/Roadmap";
import CompanyLogos from "./CompanyLogos";
const Roadmap = () => (
  <Section className="overflow-hidden" id="roadmap">
    <div className="container md:pb-10">
      <Heading tag="Ready to get started" title="Our Features" />

      <div className="relative grid gap-6 md:grid-cols-2 md:gap-4 md:pb-[7rem]">
        {roadmap.map((item) => {
          const status = item.status === "done" ? "Done" : "In progress";
          return (
            <div
              className={`md:flex even:md:translate-y-[7rem] p-0.25 rounded-[2.5rem] ${
                item.colorful ? "bg-conic-gradient" : "bg-n-6"
              }`}
              key={item.id}
            >
              <div className="relative p-8 bg-n-8 rounded-[2.4375rem] overflow-hidden xl:p-15">
                <div className="absolute top-0 left-0 max-w-">
                  <img
                    className="w-full"
                    src={grid}
                    width={550}
                    height={550}
                    alt="Grid"
                  />
                </div>
                <div className="relative z-1">
                  {/* <div className="flex items-center justify-end max-w-[27rem] mb-8 md:mb-20"> */}
                    {/* <Tagline>{item.date}</Tagline> */}

                    {/* <div className="flex items-center px-4 py-1 bg-n-1 rounded text-n-8">
                      <img
                      className="mr-2.5"
                      src={item.status === "done" ? check2 : loading1}
                      width={16}
                      height={16}
                      alt={status}
                      />
                      <div className="tagline">{status}</div>
                      </div>
                      </div> */}

                      <a href={item.url} target="_blank" rel="noopener noreferrer">
                  <div className="mb-10 my-auto mx-auto cursor-pointer">
                    <img
                      className="w-3xl"
                      src={item.imageUrl}
                      width={500}
                      height={300}
                      alt={item.title}
                    />
                  </div>
                  <h4 className="h4 mb-4">{item.title}</h4>
                  <p className="body-2 text-n-2">{item.text}</p> 
                  </a>
                </div>
              </div>
            </div>
          );
        })}

        <Gradient />
      </div>
      {/* <div>
        <h1>Ready...!!</h1>
      </div> */}
      {/* <div className="flex justify-center mt-12 md:mt-15 xl:mt-20">
        <Button href="/roadmap">Our roadmap</Button>
      </div>
      <CompanyLogos className="hidden relative z-10 mt-20 lg:block" /> */}

    </div>
  </Section>
);

export default Roadmap;
